module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp13_7005.c8e02b16.png";